module.exports = __webpack_public_path__ + "static/covid-for-organizations-c5d61397ca66432415061df32f230d62.jpg";